import { render, staticRenderFns } from "./LogoUploadBox.vue?vue&type=template&id=6abbd116&scoped=true&"
import script from "./LogoUploadBox.vue?vue&type=script&lang=js&"
export * from "./LogoUploadBox.vue?vue&type=script&lang=js&"
import style0 from "./LogoUploadBox.vue?vue&type=style&index=0&id=6abbd116&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abbd116",
  null
  
)

export default component.exports